import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

export const phoneNumberAutoFormat = (phoneNumber) => {
  const number = phoneNumber.trim().replace(/[^0-9]/g, "");

  if (number.length < 4) return number;
  if (number.length < 7) return number.replace(/(\d{3})(\d{1})/, "$1-$2");
  if (number.length < 11)
    return number.replace(
      /(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/,
      "$1.$2.$3.$4.$5",
    );
  return number.replace(
    /(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/,
    "$1-$2.$3.$4.$5",
  );
};

export const esParOImpar = (numero) => {
  if (numero % 2 === 0) {
    return 1;
  } else {
    return 0;
  }
};

export const calculaEdad = (e) => {
  const hoy = new Date(); // Fecha actual
  const fechaNac = new Date(e); // Fecha de nacimiento del input

  let edad = hoy.getFullYear() - fechaNac.getFullYear(); // Diferencia de años inicial

  const mesActual = hoy.getMonth();
  const mesNac = fechaNac.getMonth();

  // Si el mes actual es menor que el mes de nacimiento, no ha cumplido años
  if (mesActual < mesNac) {
    edad--;
  } else if (mesActual === mesNac) {
    // Si los meses son iguales, revisamos el día
    const diaActual = hoy.getDate();
    const diaNac = fechaNac.getDate();
    if (diaActual < diaNac) {
      edad--; // No ha cumplido años aún en el mes actual
    }
  }

  // Para obtener meses y días exactos (más complejo, pero posible)
  // Se puede calcular la diferencia en milisegundos y convertir, o iterar meses/días
  // El método anterior solo da los años cumplidos.
  return edad;
};

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

export const exportToExcel = (apiData, fileName) => {
  const ws = XLSX.utils.json_to_sheet(apiData); // Converts JSON array to a worksheet
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  saveAs(data, fileName + fileExtension); // Saves the file with the specified name
};

export const reformatDateString = (dateString) => {
  // Split the string by the '/' delimiter
  let dateParts = dateString.split("/");

  // Rearrange the parts into the YYYY-MM-DD format
  // dateParts[2] is the year, dateParts[1] is the month, dateParts[0] is the day
  let newDateFormat = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;

  return newDateFormat;
};

export const soloNumeros = (event) => {
  const inputValue = event.target.value;
  // Regex to allow numbers (0-9), a single decimal point (.), and handle the case of an empty string
  const regex = /^\d*\.?\d*$/;

  if (regex.test(inputValue) || inputValue === "") {
    return inputValue;
  } else {
    return "";
  }
};

